import classNames from "classnames";
import * as React from "react";

import {
  AutocompleteType,
  TagAndMetadataAutocomplete,
} from "../TagAndMetadataAutocomplete";

import styles from "./MetadataForm.module.css";
import { Metadata } from "./types";

interface Props {
  metadata: Metadata;
  autocompleteType: AutocompleteType;
  onAddMetadata: (key: string, value: unknown) => void;
  className?: classNames.Argument;
  placeholderKeyName?: string;
  disabled?: boolean;
  isLoading?: boolean;
  jsonMetadataDisabled?: boolean;
}

export const MetadataForm: React.FC<Props> = ({
  metadata,
  autocompleteType,
  onAddMetadata,
  className,
  placeholderKeyName = "Key",
  disabled = false,
  isLoading = false,
  jsonMetadataDisabled = false,
}) => {
  return (
    <div className={classNames(styles.root, className)}>
      <TagAndMetadataAutocomplete
        autocompleteType={autocompleteType}
        onMetadataCreated={onAddMetadata}
        keyPlaceholderText={placeholderKeyName}
        existingMetadata={metadata}
        disabled={disabled}
        isLoading={isLoading}
        jsonMetadataDisabled={jsonMetadataDisabled}
      />
    </div>
  );
};
